module.exports = __webpack_public_path__ + "img/0.949037e2.gif";